/**
 * Tax Reporting API Client
 * Fetches 1099-K tax forms and YTD summary for the landlord portal.
 */

import { z } from 'zod';
import { apiFetch } from '../lib/api';
import {
  TaxForm1099KSchema,
  YtdSummaryResponseSchema,
} from '@resida/api-types/tax-reporting';

export type TaxFormStatus = 'CREATED' | 'FINALIZED' | 'FILED' | 'RECIPIENT_NOTIFIED';

// Derived from TaxForm1099KSchema in @resida/api-types/tax-reporting
export type TaxForm1099K = z.infer<typeof TaxForm1099KSchema>;

// Derived from YtdSummaryResponseSchema in @resida/api-types/tax-reporting
export type YtdSummary = z.infer<typeof YtdSummaryResponseSchema>;

export async function fetchTaxForms(): Promise<{ forms: TaxForm1099K[] }> {
  return apiFetch('/landlord/api/tax/1099k');
}

export async function fetchTaxFormPdfUrl(id: string): Promise<{ url: string }> {
  return apiFetch(`/landlord/api/tax/1099k/${id}/pdf`);
}
